import * as yup from 'yup';
import { greaterThenMsg, minZeroMsg, requiredMsg, typeMsg } from '../../utils/validationMessages';
import { transactionDateSchema } from '../../../../../../Finance2/Forms/transactionFieldSchemas';
import {
  percentField,
  usdField,
  pricePerShareField,
  sharesField,
} from '../../../../../../../schemas/common-schema-defs';

export function tokenSaftFields() {
  return {
    fundId: yup.number().nullable().required(requiredMsg('Fund')),
    transactionDate: transactionDateSchema(),
    pricePerShare: pricePerShareField()
      .required()
      .min(0, minZeroMsg('Price Per Token'))
      .nullable()
      .typeError(typeMsg('Price Per Token', 'number')),
    noOfShares: sharesField()
      .typeError(typeMsg('Shares Purchased', 'number'))
      .required(requiredMsg('Shares Purchased'))
      .min(0, minZeroMsg('Shares Purchased')),
    valuationCap: usdField().optional().min(0, minZeroMsg('Valuation Cap')).nullable(),
    discountRate: percentField().min(0, greaterThenMsg('Discount rate', 0)).optional().nullable(),
  };
}

export function tokenSaftFormSchema() {
  return yup.object().shape(tokenSaftFields());
}

export function tokenSaftGridSchema() {
  return yup.object().shape(tokenSaftFields());
}
